import {all, fork} from "redux-saga/effects";
import transactionSaga from "./transaction";
import deviceSaga from "./device";
import alarmAnalysisSaga from "./alarmAnalysis";
import notificationEventsSaga from "./notificationEvent";
function* TransactionLogSaga(){
  yield all([
    fork(transactionSaga),
    fork(deviceSaga),
    fork(alarmAnalysisSaga),
    fork(notificationEventsSaga)
  ])
}
export default TransactionLogSaga;
